import { render, staticRenderFns } from "./inquiryList.vue?vue&type=template&id=1f272ea8&scoped=true"
import script from "./inquiryList.vue?vue&type=script&lang=js"
export * from "./inquiryList.vue?vue&type=script&lang=js"
import style0 from "./inquiryList.vue?vue&type=style&index=0&id=1f272ea8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f272ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f272ea8')) {
      api.createRecord('1f272ea8', component.options)
    } else {
      api.reload('1f272ea8', component.options)
    }
    module.hot.accept("./inquiryList.vue?vue&type=template&id=1f272ea8&scoped=true", function () {
      api.rerender('1f272ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/inquiryList.vue"
export default component.exports